var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIPhone3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7072 182.508C46.0758 199.735 79.4506 198.209 97.7448 178.617C107.976 168.946 113.68 154.964 113.772 140.893C113.426 105.671 114.04 62.5399 113.76 27.3165C113.534 27.03 113.084 26.4701 112.859 26.1835C108.515 26.355 104.169 27.3417 100.13 28.9821C92.45 32.7314 87.9576 41.8841 88.1407 50.5866C88.2805 78.4612 86.5326 113.35 86.6594 141.225C86.7792 156.595 72.0058 170.556 56.6438 168.14C45.6833 167.13 36.5333 158.26 33.615 147.816C32.2394 140.864 32.6313 133.311 36.2099 127.061C40.6363 119.696 48.2101 113.621 56.9996 113.145C63.9527 112.833 70.919 112.796 77.8872 112.813C79.6734 112.817 81.1192 111.35 81.0975 109.551L80.8596 89.7837C80.8372 87.9252 79.2624 86.4728 77.4193 86.5578C68.9112 86.9502 60.0296 86.569 51.6398 87.4251C35.0263 89.4427 20.2034 100.38 11.9344 114.827C-0.328191 136.817 5.53245 167.291 25.7072 182.508Z",
    fill: "url(#paint0_linear_184_283)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.293 17.4916C153.924 0.265158 120.549 1.79059 102.255 21.3829C92.0236 31.0542 86.3197 45.0358 86.2281 59.1066C86.5739 94.3291 87.1227 130.432 87.4032 165.656C87.6284 165.942 88.0789 166.502 88.3042 166.789C92.6475 166.617 96.9941 165.631 101.033 163.99C108.713 160.241 113.205 151.967 113.022 143.264C112.882 115.389 113.467 86.6501 113.341 58.7753C113.221 43.4053 127.994 29.4445 143.356 31.8603C154.317 32.8704 163.467 41.7395 166.385 52.1838C167.761 59.1361 167.369 66.6885 163.79 72.9387C159.364 80.3037 151.79 86.3791 143.001 86.8547C136.047 87.1673 129.081 87.2042 122.113 87.187C120.327 87.1826 118.881 88.6501 118.903 90.4494L119.141 110.216C119.163 112.075 120.738 113.527 122.581 113.442C131.089 113.05 139.97 113.431 148.36 112.575C164.974 110.557 179.797 99.6201 188.066 85.1733C200.328 63.1827 194.468 32.7086 174.293 17.4916Z",
    fill: "url(#paint1_linear_184_283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_283",
    x1: -69.7001,
    y1: 211.067,
    x2: 299.556,
    y2: -36.4882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33A8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#3CE9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30E06A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184_283",
    x1: -69.7001,
    y1: 211.067,
    x2: 299.556,
    y2: -36.4882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33A8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#3CE9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30E06A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPhone3);
export default __webpack_public_path__ + "static/media/iPhone3.5316ad150371c02c97efdf608c17147c.svg";
export { ForwardRef as ReactComponent };